/** @jsxImportSource @emotion/react */
import React from 'react'
import PropTypes from 'prop-types'
import estyled from '@signal/theme/emotion'
import _sortBy from 'lodash/sortBy'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'

export const DOT_CHAR = 'o'
export const DOT_SIZE_DEFAULT = 3

const DotsSvg = estyled.svg`
  position: absolute;
  margin: ${({ dotSize }) => dotSize}px;
  overflow: hidden;
`

const DEFAULT_DOT_PATTERN = [
  'ooooooooooooooooooo  ooo  oo',
  'oooooooooooooooooo  oooo  o',
  'oooooooooooooooooo  oooo',
  'ooooooooo oooo ooooooooooo',
  'oo oo ooo  oo   ooo o  ooo',
  ' o  o  o    o           oo'
]

const PureCarsDots = props => {
  const { dotSize, dotPattern, dotColor, reversed, ...rest } = props
  const dotRadius = (dotSize * 9) / 6
  const longestDotLine = _sortBy(dotPattern, lineCur => -lineCur.length)[0]
    .length
  const width = longestDotLine * (dotRadius * 2 + dotSize) - dotSize
  const height = dotPattern.length * (dotRadius * 2 + dotSize) - dotSize

  return (
    <DotsSvg
      data-testid="pureCarsDots-svg"
      version="1.1"
      id="Dots"
      x="0px"
      y="0px"
      width={width}
      height={height}
      fill={dotColor}
      dotSize={dotSize}
      {...rest}
    >
      {dotPattern.reduce((_markup, lineCur, dotY) => {
        var lineAry = lineCur.split('')
        while (lineAry.length < longestDotLine) {
          lineAry.push(' ')
        }
        ;(reversed ? lineAry.reverse() : lineAry).forEach((dotCur, dotX) => {
          if (dotCur === DOT_CHAR) {
            const dotOffset = dotRadius * 2 + dotSize
            _markup.push(
              <circle
                key={Math.random()}
                cx={dotX * dotOffset + dotRadius}
                cy={dotY * dotOffset + dotRadius}
                r={dotRadius}
              />
            )
          }
        })
        return _markup
      }, [])}
    </DotsSvg>
  )
}

PureCarsDots.propTypes = {
  dotColor: PropTypes.string,
  dotPattern: PropTypes.arrayOf(PropTypes.string),
  dotSize: PropTypes.number,
  reversed: PropTypes.bool
}

PureCarsDots.defaultProps = {
  dotColor: 'white',
  dotPattern: DEFAULT_DOT_PATTERN,
  dotSize: DOT_SIZE_DEFAULT
}

export default withCommonSnapshotsOnly(PureCarsDots)
